const getters = {
  paginate_companies: (state) => state.paginate_companies,
  pagination_companies: (state) => state.pagination_companies,
  exist_only_one_company: (state) =>
    state.paginate_companies && state.paginate_companies.length === 1,
  simple_companies: (state) => state.simple_companies,
}

export default getters
